<template>
  <div class="ds-noticia">
    <el-carousel
      ref="carousel"
      :interval="500000"
      :height="carouselHeight"
      arrow="always"
      indicator-position="none"
      class="ds-noticia-carousel"
      @change="onCarouselChange"
    >
      <el-carousel-item v-for="item in data" :key="item.Id">
        <router-link :to="{ name: 'Noticia', params: { id: item.Id } }" class="ds-noticia__link">
          <article class="ds-noticia__item">
            <div class="ds-noticia__image-container">
              <img
                v-if="item.PathImagen"
                class="ds-noticia__image"
                :src="item.PathImagen"
                :alt="item.Titulo"
              >
              <img
                v-else
                class="ds-noticia__image ds-noticia__image--default"
                src="../../images/logo.png"
                :alt="item.Titulo"
              >
            </div>

            <div class="ds-noticia__content">
              <h2 class="ds-h2 ds-noticia__title">{{ item.Titulo }}</h2>
              <p class="ds-body-big ds-noticia__text">{{ item.Copete }}</p>
            </div>
          </article>
        </router-link>
      </el-carousel-item>
    </el-carousel>

    <div v-if="data.length > 1" class="ds-noticia__indicators" aria-label="Selector de noticia">
      <button
        v-for="(item, index) in data"
        :key="`dot-${item.Id || index}`"
        type="button"
        class="ds-noticia__indicator-btn"
        :class="{ 'is-active': index === activeSlide }"
        :aria-label="`Ir a noticia ${index + 1}`"
        @click="goToSlide(index)"
      ></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DsNoticia',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      viewportWidth: window.innerWidth,
      activeSlide: 0
    }
  },
  computed: {
    carouselHeight() {
      if (this.viewportWidth <= 480) {
        return '500px'
      }

      if (this.viewportWidth <= 1200) {
        return '500px'
      }

      return '405px'
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.viewportWidth = window.innerWidth
    },
    onCarouselChange(index) {
      this.activeSlide = index
    },
    goToSlide(index) {
      this.activeSlide = index
      if (this.$refs.carousel) {
        this.$refs.carousel.setActiveItem(index)
      }
    }
  }
}
</script>

<style scoped>
.ds-noticia {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  width: 100%;
}

.ds-noticia-carousel {
  width: 100%;
}

.ds-noticia__indicators {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.ds-noticia__indicator-btn {
  width: 43px;
  height: 6px;
  border: 0;
  padding: 0;
  background-color: var(--ds-color-neutral-200);
  cursor: pointer;
}

.ds-noticia__indicator-btn.is-active {
  background-color: var(--ds-color-brand-500);
}

.ds-noticia__link {
  display: block;
  width: 100%;
  color: inherit;
  text-decoration: none;
}

.ds-noticia__item {
  display: flex;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 32px;
  align-items: center;
  gap: 40px;
  align-self: stretch;
  background: var(--ds-color-neutral-50);
  border-radius: 8px;
}

.ds-noticia__image-container {
  width: 400px;
  height: 340px;
  flex: 0 0 auto;
  overflow: hidden;
  background: var(--ds-color-neutral-200);
}

.ds-noticia__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ds-noticia__image--default {
  object-fit: contain;
  padding: 24px;
  box-sizing: border-box;
}

.ds-noticia__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  flex: 1 1 0;
  min-width: 0;
}

.ds-noticia__title {
  margin: 0;
  color: var(--ds-color-neutral-600);
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.ds-noticia__text {
  margin: 0;
  color: var(--ds-color-neutral-600);
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

@media (max-width: 1200px) {
  .ds-noticia__item {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
    gap: 20px;
  }

  .ds-noticia__image-container {
    width: 100%;
    height: 250px;
  }

  .ds-noticia__content {
    width: 100%;
    min-height: 250px;
    gap: 12px;
  }

  .ds-noticia__title {
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }

  .ds-noticia__text {
    -webkit-line-clamp: 3;
    line-clamp: 3;
  }
}
</style>

<style>
.ds-noticia-carousel.el-carousel {
  background-color: var(--ds-color-neutral-0);
  text-align: left;
  align-self: stretch;
}

.ds-noticia-carousel .el-carousel__button {
  width: 43px;
  height: 6px;
  background-color: var(--ds-color-neutral-200);
  opacity: 1;
}

.ds-noticia-carousel .el-carousel__indicator.is-active .el-carousel__button {
  background-color: var(--ds-color-brand-500);
}

.ds-noticia-carousel .el-carousel__container {
  width: 100%;
  background-color: var(--ds-color-neutral-0);
}

.ds-noticia-carousel .el-carousel__indicators {
  background-color: var(--ds-color-neutral-0);
  display: none;
}

@media (max-width: 1200px) {
  .ds-noticia-carousel .el-carousel__container {
    overflow: hidden;
  }

  .ds-noticia__indicators {
    gap: 6px;
  }
}
</style>
